export interface Solution {
    id: string;
    title: string;
    imagePath: string;
}

export const solutions: Solution[] = [
    {
        id: "oceanbase",
        title: "MPA Monitoring",
        imagePath: "/images/product-images/mpa2.png"
    },
    {
        id: "coralguard",
        title: "Coral Reef Monitoring",
        imagePath: "/images/product-images/coral-reef.png"
    },
    {
        id: "bluefinance",
        title: "Blue Finance Impact Monitoring",
        imagePath: "/images/product-images/blue-finance.png"
    },
    {
        id: "aquapath",
        title: "Aquaculture Support Services",
        imagePath: "/images/product-images/aquaculture.png"
    },
    {
        id: "inframonitor",
        title: "Offshore Impact Assessment",
        imagePath: "/images/product-images/offshore-windfarm.png"
    },
    {
        id: "genomelab",
        title: "MGR Discovery & Bioprospecting",
        imagePath: "/images/product-images/bioprospecting.png"
    }
];
